import { useRef } from 'react';
import { tTypeAttachment } from '../../MessageBubble.type.ts';
import './VideoContent.styles.scss';

export default function VideoContent(props: tTypeAttachment) {
  const vidRef = useRef<HTMLVideoElement | null>(null);

  return (
    <video
      ref={vidRef}
      src={props.attachment.url ?? ''}
      className="w-72 max-h-80 mb-1 rounded-md object-cover"
      muted
      controls
    />
  );
}
